import { styled } from '@mui/system'
import theme from 'src/assets/colors/theme'

export const BackdropWrapper = styled('div')({
  '& .solid': {
    background: theme.PRIMARY,
  },
})
